import { useAppState } from "../providers/app-state";
import { BsTrash } from 'react-icons/bs'

const OrderInfo = ({ canDelete }) => {
    const { state, dispatch } = useAppState();

    return (
        <div
            className="w-full flex flex-col px-4 text-xs divide-y font-light"
        >
            <div
                className="py-5 text-lg font-normal"
            >
                Dine valg
            </div>
            {
                !!state.selectedRepairs.length
                    ? (
                        <>
                            {
                                state.selectedRepairs.map((repair, index) => {
                                    return (
                                        <div
                                            className="py-3 flex items-center justify-between"
                                            key={index}
                                        >
                                            <span>
                                                {repair.name}
                                            </span>
                                            {
                                                canDelete
                                                    ? (
                                                        <BsTrash
                                                            size={15}
                                                            className="text-skgRed cursor-pointer"
                                                            onClick={() => {
                                                                const y = [...state.selectedRepairs];
                                                                y.splice(index, 1);
                                                                dispatch({
                                                                    key: "selectedRepairs",
                                                                    value: y
                                                                })
                                                            }}
                                                        />
                                                    )
                                                    : null
                                            }
                                        </div>
                                    )
                                })
                            }
                        </>
                    )
                    : (
                        <div
                            className="py-3"
                        >
                            <p>Ingen valgte reparationer</p>
                        </div>
                    )
            }
            {
                state.selectedUpsales.map((repair, i) => {
                    return (
                        <div
                            className="py-3"
                            key={i}
                        >
                            <span>
                                {repair.name}
                            </span>
                            <br />
                            <span
                                className="font-bold"
                            >
                                RABAT:
                            </span>
                            <span
                                className="font-normal italic"
                            >
                                {" " + repair.discount_pct.split(".")[0] + "%"}
                            </span>
                        </div>
                    )
                })
            }
            {
                state.selectedShop && (
                    <div
                        className="py-3 space-y-1"
                    >
                        <div
                            className="flex flex-row justify-between"
                        >
                            <p>Afdeling:</p>
                            <p>{state.selectedShop.name}</p>

                        </div>
                        {/* {
                            state.selectedDate
                                ? (
                                    <div
                                        className="flex flex-row justify-between"
                                    >
                                        <p>Dato:</p>
                                        <p>{state.selectedDate.format("DD/MM/YYYY")}</p>
                                    </div>
                                )
                                : null
                        }
                        {
                            state.timeOption === 2
                                ? (
                                    <div
                                        className="flex flex-row justify-between"
                                    >
                                        <p>Tid:</p>
                                        <p>Hele dagen</p>
                                    </div>
                                )
                                : (
                                    <>
                                        <div
                                            className="flex flex-row justify-between"
                                        >
                                            <p>Tid:</p>
                                            <p>Hele dagen</p>
                                        </div>
                                        <div
                                            className="flex flex-row justify-between"
                                        >
                                            <p>Tid:</p>
                                            <p>Hele dagen</p>
                                        </div>
                                    </>
                                )
                        } */}
                    </div>
                )
            }
        </div>
    )
}

export default OrderInfo;